import React, { useEffect, useState } from "react";
import { createElement } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function DeleteProduct() {
    const [backendData, setData] = useState();
    let reUseEfect = 0;

    useEffect(() => {
        fetchDelete();
    }, []);

    const fetchDelete = async () => {
        const res = await fetch("/delete", {
            method: "POST"
        })
            .then((res) => res.json())
            .catch((error) => console.log(error));
        setData(res);
    }

    function deleteImg(product, id) {
        const formData = new FormData();
        formData.append("product", product);
        formData.append("id", id);
        alert("האם אתה בטוח במחיקת התמונה?");
        const jsonData = {};
        for (let [key, value] of formData) {
            jsonData[key] = value;
        }
        fetch("/delete-img", {
            method: "POST",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(jsonData)
        }).then((res) => res.json())
            .then((res) => {
                if (res.deletemysql) {
                    alert("התמונה נמחקה בהצלחה");
                    window.location = "/delete";
                } else {
                    alert("התמונה לא נמחקה בהצלחה")
                }
            })
    }

    return (
        <div className="container mt-5">
            <h1 className="text-center mb-4">מחיקת תמונה</h1>
            <div className="card shadow-sm p-4">
                <h2 className="text-center mb-4">נא לבחור תמונה שברצונך למחוק</h2>
                <div className="row">
                    {typeof backendData === "undefined" ? (
                        <div className="text-center">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p>Loading...</p>
                        </div>
                    ) : (
                        backendData.tableSql.map((a, i) => (
                            <div key={i} className="col-6 col-md-4 col-lg-3 mb-4">
                                <div className="card h-100">
                                    {createElement("img", {
                                        src: a.url,
                                        className: "card-img-top img-fluid",
                                        style: { cursor: "pointer", objectFit: "cover", height: "200px" },
                                        onClick: () => deleteImg(a.product, a.id_product)
                                    })}
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    )
}

export default DeleteProduct